import { AsyncPipe, isPlatformBrowser, isPlatformServer } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  inject,
  makeStateKey,
  OnInit,
  PLATFORM_ID,
  signal,
  TransferState,
} from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTabsModule } from '@angular/material/tabs'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'
import { BehaviorSubject, combineLatest, filter, map, takeUntil } from 'rxjs'

import { UserSectionAccessComponent } from '~/core/components'
import { DestroyDirective } from '~/core/directives'
import {
  COMPANY_FACADE,
  FORECAST_LIST_FACADE,
  ICompanyFacade,
  IForecastListFacade,
  IRouterFacade,
  IUserFacade,
  ROUTER_FACADE,
  USER_FACADE,
} from '~/core/features'
import { EGuardEntityName, EGuardSection, EGuardSectionName } from '~/core/models'

import { CompanyHeaderCardComponent } from './components/company-header-card/company-header-card.component'
import { ForecastNotFoundComponent } from './components/forecast-not-found/forecast-not-found.component'
import { TAB_LINKS } from './constants'

const dataKey = makeStateKey<{ data: string }>('data')

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrl: './company-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [
    AsyncPipe,
    RouterLink,
    RouterOutlet,
    MatIconModule,
    MatTabsModule,
    TranslateModule,
    RouterLinkActive,
    ForecastNotFoundComponent,
    UserSectionAccessComponent,
    CompanyHeaderCardComponent,
  ],
})
export class CompanyInfoComponent implements OnInit {
  readonly guardSection = signal<EGuardSection | null | undefined>(undefined)
  readonly isGranted = signal<boolean>(false)
  readonly isGranted$ = new BehaviorSubject<Boolean>(true)
  readonly inRequest$ = new BehaviorSubject<Boolean>(false)

  private readonly destroy$ = inject(DestroyDirective).destroy$

  TAB_LINKS = TAB_LINKS
  EGuardSection = EGuardSection
  EGuardEntityName = EGuardEntityName
  EGuardSectionName = EGuardSectionName

  constructor(
    @Inject(FORECAST_LIST_FACADE) private forecastListFacade: IForecastListFacade,
    @Inject(COMPANY_FACADE) public companyFacade: ICompanyFacade,
    @Inject(ROUTER_FACADE) public routerFacade: IRouterFacade,
    @Inject(USER_FACADE) public userFacade: IUserFacade,
    @Inject(PLATFORM_ID) private platformID: Object,
    private transferState: TransferState
  ) {}

  ngOnInit(): void {
    this.routerFacade.isCompanyPage$.pipe(takeUntil(this.destroy$)).subscribe(isCompanyPage => {
      this.guardSection.set(isCompanyPage ? EGuardSection.COMPANY_INFO : EGuardSection.FORECAST_INFO)
    })

    console.log('AAAA')

    combineLatest([this.routerFacade.guardSectionName$, this.userFacade.permissionSectionEntities$])
      .pipe(
        filter(([guardSectionName, permissionSectionEntities]) =>
          Boolean(guardSectionName && permissionSectionEntities)
        ),
        map(([guardSectionName, permissionSectionEntities]) => permissionSectionEntities![guardSectionName!]),
        map(permissions => permissions[EGuardEntityName.FORECAST]['eps_forecast_proximilar']),
        takeUntil(this.destroy$)
      )
      .subscribe(isGranted => {
        this.isGranted.set(isGranted)
        console.log('isGranted', isGranted)
        // this.isGranted$.next(isGranted)
      })

    combineLatest([this.forecastListFacade.inRequest$, this.companyFacade.inRequest$])
      .pipe(
        map(([inRequestForecast, inRequestCompany]) => inRequestForecast || inRequestCompany),
        takeUntil(this.destroy$)
      )
      .subscribe(inRequest => this.inRequest$.next(inRequest))

    if (isPlatformServer(this.platformID)) {
      //<--- this block run on server
      this.transferState.set(dataKey, { data: 'AAAAA' })
      console.log('SERV data', this.transferState.get<{ data: string }>(dataKey, { data: '' }))
    } else if (isPlatformBrowser(this.platformID)) {
      console.log('CLIENT data', this.transferState.get<{ data: string }>(dataKey, { data: '' }))
    }
  }
}
